import { useQuery } from '@tanstack/react-query'
import { useAxios } from 'packages/core'

export const JUSTIFICATION_OPTIONS_KEY = 'JUSTIFICATION_OPTIONS'
export const useJustificationOptions = () => {
    const callApi = useAxios()

    return useQuery(
        [JUSTIFICATION_OPTIONS_KEY],
        async () => {
            const response = await callApi({
                method: 'GET',
                url: 'api/v1/Delegation/PredefinedJustifications',
            })

            return response.data
        },
        {
            staleTime: Infinity, // Data never becomes stale
            cacheTime: Infinity, // Keep in cache forever (even when unmounted)
        },
    )
}
